import React from 'react';
import { Outlet } from 'react-router-dom';

const UnProtectedLayout = () => {
    return (
        <div className="container">
            <div className='m-5'>
                <Outlet />
            </div>
        </div>
    )
};

export default UnProtectedLayout;